export default {
    dollarFormatted,
    reducer,
    scrollTop,
}

function dollarFormatted(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function reducer(accumulator, currentValue) {
    return accumulator + currentValue;
}

function scrollTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}